.countdownOverlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.12);
  animation: deliver-shrink 10s linear forwards;
}

@keyframes deliver-shrink {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}
